import { DateFieldLabel } from './DateFieldLabel';
import { DateDisplayMode } from './DateDisplayMode';
import { DateEditMode } from './DateEditMode';
import { DatePickerPopover } from './DatePickerPopover';
import { ConfirmDateChangeDialog } from './ConfirmDateChangeDialog';
import { isNotNullOrUndefined } from '@vy/utils';
import { formatDate } from '../../../../../utils/date';
import { Stack } from '@mui/material';
import { FC, useRef } from 'react';
import { useEditableDateField } from './hooks/useEditableDateField';

type EditableContractDateFieldProps = {
  label: string;
  value: Date | undefined;
  onSave: (date: Date | null) => Promise<void>;
  contractEndDate: Date;
};

export const EditableContractDateField: FC<EditableContractDateFieldProps> = ({
  label,
  value,
  onSave,
  contractEndDate,
}) => {
  const calendarIconRef = useRef<HTMLButtonElement>(null);

  const {
    isEditMode,
    editedDate,
    isConfirmDialogOpen,
    isDatePickerOpen,
    confirmSave,
    cancelEdit,
    handleCalendarClick,
    handleConfirmDialogClose,
    handleConfirmDialogSubmit,
    handleDatePickerChange,
    handleDatePickerClose,
    enterEditMode,
  } = useEditableDateField({ value, onSave });
  const displayDate = isNotNullOrUndefined(editedDate) ? formatDate(editedDate) : 'N/A';
  const currentDisplayDate = isNotNullOrUndefined(value) ? formatDate(value) : 'N/A';
  return (
    <Stack spacing="6px">
      <DateFieldLabel label={label} />
      <Stack spacing="6px">
        {!isEditMode ? (
          <DateDisplayMode displayDate={currentDisplayDate} onEdit={enterEditMode} />
        ) : (
          <DateEditMode
            displayDate={displayDate}
            calendarIconRef={calendarIconRef}
            onCalendarClick={handleCalendarClick}
            onConfirm={confirmSave}
            onCancel={cancelEdit}
          />
        )}

        <DatePickerPopover
          open={isDatePickerOpen}
          anchorEl={calendarIconRef}
          selectedDate={editedDate}
          onClose={handleDatePickerClose}
          contractEndDate={contractEndDate}
          onChange={handleDatePickerChange}
        />
        <ConfirmDateChangeDialog
          open={isConfirmDialogOpen}
          onClose={handleConfirmDialogClose}
          onConfirm={handleConfirmDialogSubmit}
        />
      </Stack>
    </Stack>
  );
};